export default function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/@popperjs+core@2.9.2/~/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
// module id = 144
// module chunks = 75